'use client'

import * as React from 'react'
import { ToasterCustom } from '@web/components/toaster'
import toast from 'react-hot-toast'
import { useTranslations } from 'next-intl'
import { sessionStore } from 'utils/storage'

export function AccountDeletedNotice() {
  return (
    <>
      <ToasterCustom />
      <AccountDeletedNoticeHandler />
    </>
  )
}

function AccountDeletedNoticeHandler() {
  const t = useTranslations('pages.home.notices')
  React.useEffect(() => {
    const accountDeleted = sessionStore.getString('accountDeleted')
    if (accountDeleted) {
      toast.success(t('account_deleted'), {
        duration: 10_000,
      })
      sessionStore.remove('accountDeleted')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <></>
}
